module.exports = __webpack_public_path__ + "static/img/IMG_20160918_154330.90512223.jpg";